import { useState, useRef, useEffect } from 'react';
import { Input, Spin } from 'antd';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';
import { TacheService } from '../../services/TacheService';
import { catchError } from '../../services/DaoService';
import PropTypes from 'prop-types';
import styles from './InlineTacheCreator.module.scss';

export default function InlineTacheCreator({ affaireId = null, onCreated }) {
  const [active, setActive] = useState(false);
  const [nom, setNom] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (active) inputRef.current?.focus();
  }, [active]);

  const reset = () => { setActive(false); setNom(''); };

  const submit = () => {
    const trimmed = nom.trim();
    if (!trimmed) { reset(); return; }
    setLoading(true);
    TacheService.getInstance()
      .create({ nom: trimmed, ...(affaireId ? { affaire_id: affaireId } : {}) })
      .then(res => { onCreated?.(res.data); reset(); })
      .catch(catchError)
      .finally(() => setLoading(false));
  };

  if (!active) {
    return (
      <div className={styles.trigger} onClick={() => setActive(true)}>
        <PlusOutlined className={styles.triggerIcon} />
        <span>Ajouter une tâche</span>
      </div>
    );
  }

  return (
    <div className={styles.row}>
      <Spin spinning={loading} size="small">
        <Input
          ref={inputRef}
          value={nom}
          onChange={e => setNom(e.target.value)}
          onPressEnter={submit}
          onKeyDown={e => e.key === 'Escape' && reset()}
          placeholder="Nom de la tâche… (Entrée pour créer, Échap pour annuler)"
          className={styles.input}
          suffix={<CloseOutlined className={styles.cancelIcon} onClick={reset} />}
        />
      </Spin>
    </div>
  );
}

InlineTacheCreator.propTypes = {
  affaireId: PropTypes.number,
  onCreated: PropTypes.func,
};
